export default "__VITE_ASSET__BmMrF6Nx__"